<template>
  <in-app-browser-link class="accept-shift-modal-terms" :href="pdfUrl">
    <download-icon />
    {{label}}
  </in-app-browser-link>
</template>
<script lang="ts" setup>
import InAppBrowserLink from '@app/components/InAppBrowserLink.vue';
import { DownloadIcon } from '@pidz/icons';

defineProps<{
  pdfUrl:string,
  label:string,
}>();

</script>
<style lang="scss">
.accept-shift-modal-terms{
  display: flex;
  align-items: center;
}
</style>
